module.exports = __webpack_public_path__ + "static/outlook_web_5-8afa9603d4d2c5dcc04d2ef3f41e01d3.png";